import { FC } from 'react';
import Draggable from 'react-draggable';

import {
  DIALOG_BLUE_BODY,
  ModalHeader,
  modalStyle,
  READ_ALOUD_HIGHLIGHT_BLUE,
  Readable,
} from '@gmm/problem';

interface MessageFromTeacherProps {
  close: () => void;
  text: string;
}

export const MessageFromTeacher: FC<MessageFromTeacherProps> = ({
  close,
  text,
}) => {
  return (
    <Draggable handle=".gmm-message-from-teacher">
      <div style={{ ...modalStyle, backgroundColor: DIALOG_BLUE_BODY }}>
        <ModalHeader
          title="Message"
          close={close}
          dragHandle={'gmm-message-from-teacher'}
        />

        <div style={{ height: '20px' }}></div>

        <span>From: Your Teacher</span>

        <div style={{ height: '20px' }}></div>

        <div
          style={{
            maxHeight: '100px',
            overflowY: 'auto',
            borderStyle: 'solid',
            borderColor: 'white',
            borderWidth: '1px',
            color: 'white',
            padding: '5px',
          }}
        >
          <Readable highlightColor={READ_ALOUD_HIGHLIGHT_BLUE} text={text} />
        </div>
      </div>
    </Draggable>
  );
};
